interface AppConfig {
  API_URL?: string;
  KONG_URL?: string;
  KEYCLOAK_URL?: string;
  KEYCLOAK_REALM?: string;
  KEYCLOAK_CLIENT_ID?: string;
  VERSION?: string;
  HOSTNAME?: string;
}

declare global {
  interface Window {
    APP_CONFIG?: AppConfig;
  }
}

const FALLBACK_API_URL = 'http://localhost:8000';
const FALLBACK_KEYCLOAK_URL = 'https://auth.edj-labs.com';
const FALLBACK_KEYCLOAK_REALM = 'edj-labs';
const FALLBACK_KEYCLOAK_CLIENT_ID = 'dashboard';
const LEGACY_LOCAL_API_PREFIX = 'http://localhost:8000';

const stripTrailingSlash = (value: string): string => (value || '').replace(/\/+$/, '');

const runtimeConfig: AppConfig = typeof window !== 'undefined' ? window.APP_CONFIG || {} : {};

export const API_URL: string = stripTrailingSlash(
  runtimeConfig.API_URL ||
    runtimeConfig.KONG_URL ||
    process.env.REACT_APP_API_URL ||
    process.env.REACT_APP_KONG_URL ||
    FALLBACK_API_URL
);

export const KEYCLOAK_URL: string = stripTrailingSlash(
  runtimeConfig.KEYCLOAK_URL || process.env.REACT_APP_KEYCLOAK_URL || FALLBACK_KEYCLOAK_URL
);

export const KEYCLOAK_REALM: string =
  runtimeConfig.KEYCLOAK_REALM || process.env.REACT_APP_KEYCLOAK_REALM || FALLBACK_KEYCLOAK_REALM;

export const KEYCLOAK_CLIENT_ID: string =
  runtimeConfig.KEYCLOAK_CLIENT_ID ||
  process.env.REACT_APP_KEYCLOAK_CLIENT_ID ||
  FALLBACK_KEYCLOAK_CLIENT_ID;

export const APP_VERSION: string =
  runtimeConfig.VERSION ||
  process.env.REACT_APP_VERSION ||
  'dev';

export const APP_HOSTNAME: string =
  runtimeConfig.HOSTNAME ||
  '';

export const rewriteApiUrl = (url: string): string => {
  if (typeof url !== 'string') return url;
  if (!url.startsWith(LEGACY_LOCAL_API_PREFIX)) return url;
  return `${API_URL}${url.slice(LEGACY_LOCAL_API_PREFIX.length)}`;
};
